
const DimensoesTable = ({ selectedEstandeInfo, corPrincipal }) => {
  return (
    <div>
      <div style={{
        background: "#f7f7f7",
        borderRadius: "10px",
        padding: "0.5rem",
        boxShadow: "rgba(0, 0, 0, 0.15) 1px 2px 2px 1px",
      }}>
        <h3 style={{
          fontSize: "14px",
          fontWeight: 600,
          letterSpacing: "1px",
          marginBottom: "12px",
          color: "#464373"
        }}>
          DIMENSÕES
        </h3>

        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", fontSize: "12px" }}>
          <tbody>
            {!selectedEstandeInfo?.alterou_area && (
              <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                <td style={{ padding: "8px 0", width: "50%", color: "#878A99", wordBreak: "break-word" }}>Comprimento</td>
                <td style={{ padding: "8px 0", width: "50%", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                  {selectedEstandeInfo?.comprimento} m
                </td>
              </tr>
            )}
            {!selectedEstandeInfo?.alterou_area && (
              <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                <td style={{ padding: "8px 0", color: "#878A99", wordBreak: "break-word" }}>Largura</td>
                <td style={{ padding: "8px 0", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                  {selectedEstandeInfo?.largura} m
                </td>
              </tr>
            )}
            <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
              <td style={{ padding: "8px 0", color: "#878A99", wordBreak: "break-word" }}>Altura Mínima</td>
              <td style={{ padding: "8px 0", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                {selectedEstandeInfo?.altura_minima || 'N/A'} m
              </td>
            </tr>
            <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
              <td style={{ padding: "8px 0", color: "#878A99", wordBreak: "break-word" }}>Altura Máxima</td>
              <td style={{ padding: "8px 0", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                {selectedEstandeInfo?.altura_maxima || 'N/A'} m
              </td>
            </tr>

            <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
              <td style={{ padding: "8px 0", color: "#878A99", wordBreak: "break-word" }}>Área</td>
              <td style={{ padding: "8px 0", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                {selectedEstandeInfo?.area} m²
              </td>
            </tr>

            { selectedEstandeInfo?.metragem_bonificada > 0 ? 
              <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                <td style={{ padding: "8px 0", color: "#878A99", wordBreak: "break-word" }}>Metragem Bonificada</td>
                <td style={{ padding: "8px 0", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                  {selectedEstandeInfo?.metragem_bonificada} m²
                </td>
              </tr> : <tr></tr>
            }
            
            { selectedEstandeInfo?.metragem_bonificada > 0 ? 
              <tr>
                <td style={{ padding: "8px 0", color: "#878A99", wordBreak: "break-word" }}>Área Total</td>
                <td style={{ padding: "8px 0", fontWeight: 600, textAlign: "right", wordBreak: "break-word" }}>
                  {selectedEstandeInfo?.metragem_bonificada + selectedEstandeInfo?.area} m²
                </td>
              </tr> : <tr></tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DimensoesTable;